module.exports = __webpack_public_path__ + "img/a5.99e75be8.jpg";